export default "__VITE_ASSET__CN4EUI6k__"